/* eslint-disable no-underscore-dangle */

'use-strict';

import { IScope } from 'angular';
import { PrintAPIService } from 'shared/api/print-api.service';
import { TabService } from 'shared/browser-functions/tab.service';
import { NumberConversionService } from 'shared/converter/number-converter.service';
import { FileService } from 'shared/storage/file.service';
import { DatasheetRequest } from 'src/app/@shared-types/print';
import { AutoboardVehicle } from 'src/app/@shared-types/vehicle';
import { VehicleFormComponentExitFunction } from '../../../src/app/@types/vehicle';
import { ToastService, ToastType } from '../../../ui-components/toast/toast.service';

interface DatasheetFormScope extends IScope {
  vehicle: AutoboardVehicle,
  sending: boolean,
  locations: { [key: string]: string } | null,
  exitForm: () => void,
  exit: (data: VehicleFormComponentExitFunction) => void,
  valuesChanged: () => void,
  formTransmission: () => void,
  datasheet: {
    price: string,
    featuresToShow: 'OPTIONS' | 'DETAILED',
  }
}

/* @ngInject */
export default function DatasheetController(
  $scope: DatasheetFormScope,
  numberConversionService: NumberConversionService,
  printApiService: PrintAPIService,
  tabService: TabService,
  fileService: FileService,
  toastService: ToastService,
): void {
  $scope.sending = false;

  $scope.exitForm = () => $scope.exit({ removeLock: false });

  $scope.formTransmission = async () => {
    $scope.sending = true;

    const images: string[] = [];
    const vehicleImages = $scope.vehicle.vehicleData.images;
    if (vehicleImages) {
      if (vehicleImages.length >= 0) images.push(fileService.getStaticUrl(vehicleImages[0]));
      if (vehicleImages.length >= 1) images.push(fileService.getStaticUrl(vehicleImages[1]));
    }

    const datasheetRequest: DatasheetRequest = {
      vehicleId: String($scope.vehicle._id),
      images,
      showFinancingExample: false,
      featuresToShow: $scope.datasheet.featuresToShow,
      vatRate: $scope.vehicle.vehicleData.price.vatRate || 0.19,
    };

    if ($scope.datasheet.price) {
      datasheetRequest.price = numberConversionService.parseStringFloat($scope.datasheet.price);
    }

    printApiService.getDatasheet(datasheetRequest)
      .then((datasheetHtml) => {
        tabService.openTabWithHTML(datasheetHtml.data, `Datenblatt-${$scope.vehicle._id}`, true);
        $scope.exit({});
        $scope.sending = false;
      })
      .catch(() => {
        toastService.toast(ToastType.ERROR, 'Fehler beim Generieren des Datenblatts.');
        $scope.exit({});
        $scope.sending = false;
      });
  };

  const init = () => {
    $scope.datasheet = {
      price: '',
      featuresToShow: 'OPTIONS',
    };
  };

  init();
}
